/* eslint-disable */
/* TODO: If you edit this file remove eslint-disable and fix linting errors in this file. */
require('../../core/scripts/kanban/knockKanban.controller');
require('../../core/scripts/kanban/kanbanHeader.directive');
require('../../core/scripts/kanban/kanbanColumn.directive');
require('../../core/scripts/kanban/kanbanSection.directive');
require('../../core/scripts/kanban/kanbanCard.directive');
